import React, { useState, useEffect } from 'react';
import { Card, Button, PageHeader } from '../../components/ui';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function Unsubscribes() {
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');

  useEffect(() => { fetchList(); }, []);

  const fetchList = async () => {
    setLoading(true);
    try {
      const r = await api.get('/tracking/unsubscribes');
      setList(r.data.data || []);
    } catch { toast.error('Failed to load unsubscribes'); }
    finally { setLoading(false); }
  };

  const exportCSV = async () => {
    try {
      const r = await api.get('/tracking/unsubscribes/export', { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = 'unsubscribes.csv'; a.click();
    } catch { toast.error('Export failed'); }
  };

  const filtered = list.filter(l =>
    !search ||
    l.email?.toLowerCase().includes(search.toLowerCase()) ||
    l.firstName?.toLowerCase().includes(search.toLowerCase()) ||
    l.company?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <PageHeader
        title="Unsubscribes"
        subtitle={`${list.length} contacts have unsubscribed`}
        action={
          <Button variant="secondary" onClick={exportCSV} size="sm">⬇ Export CSV</Button>
        }
      />

      <div style={{ marginBottom: 16 }}>
        <input
          placeholder="🔍 Search by email, name, company..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '100%', padding: '10px 14px', background: '#111', border: '1px solid rgba(46,204,113,0.15)', borderRadius: 10, color: '#fff', fontSize: 14, outline: 'none' }}
        />
      </div>

      {loading ? (
        <div style={{ color: '#555', textAlign: 'center', padding: 40 }}>Loading...</div>
      ) : filtered.length === 0 ? (
        <Card style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🚫</div>
          <h3 style={{ color: '#ccc', marginBottom: 8 }}>No unsubscribes yet</h3>
          <p style={{ color: '#555', fontSize: 14 }}>When contacts click the unsubscribe link, they'll appear here.</p>
        </Card>
      ) : (
        <Card style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: 'rgba(46,204,113,0.05)', borderBottom: '1px solid rgba(46,204,113,0.1)' }}>
                  {['Email', 'Name', 'Company', 'Unsubscribed At'].map(h => (
                    <th key={h} style={{ padding: '11px 14px', textAlign: 'left', color: '#555', fontWeight: 700, fontSize: 11, textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(l => (
                  <tr key={l.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 14px', color: '#E74C3C', fontWeight: 600 }}>🚫 {l.email}</td>
                    <td style={{ padding: '10px 14px', color: '#ccc' }}>{[l.firstName, l.lastName].filter(Boolean).join(' ') || '—'}</td>
                    <td style={{ padding: '10px 14px', color: '#888' }}>{l.company || '—'}</td>
                    <td style={{ padding: '10px 14px', color: '#555', fontSize: 12 }}>{l.updatedAt ? new Date(l.updatedAt).toLocaleString() : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
